module.exports = __webpack_public_path__ + "static/media/camera-background.b237c6b3.svg";